import { inject, Injectable, Type } from '@angular/core';
import { ModalService, ModalSettings } from 'mbs-ui-kit';
import { CompanyWizardComponent } from 'wizards/entity-wizards/company-wizard/company-wizard.component';
import { CompanyWizardFacade } from 'wizards/services/entity-wizards/company/company-wizard.facade';

@Injectable({ providedIn: 'root' })
export class EntityWizardsService {
  private readonly companyWizardFacade = inject(CompanyWizardFacade);
  private readonly modalService = inject(ModalService);

  public openWizard(component: Type<CompanyWizardComponent>, settings: ModalSettings): void {
    const wizard = this.modalService.openRef(component, settings);

    if (!wizard) return;

    wizard.componentInstance.orientations = 'vertical';
    wizard.result.then(() => this.resetData()).catch(() => this.resetData());
  }

  private resetData(): void {
    this.companyWizardFacade.reset();
  }
}
